module.exports = __webpack_public_path__ + "static/Brenner-komplett-bae863d4366c6226abcc3325849b941d.jpg";